import './ResultSkeleton.css';

export default function ResultSkeleton() {
  return (
    <div className="result-skeleton">
      <div className="skeleton-header">
        <div className="skeleton-icon shimmer"></div>
        <div className="skeleton-text">
          <div className="skeleton-line title shimmer"></div>
          <div className="skeleton-line subtitle shimmer"></div>
        </div>
      </div>
      <div className="skeleton-image shimmer"></div>
      <div className="skeleton-card">
        <div className="skeleton-line heading shimmer"></div>
        <div className="skeleton-grid">
          <div className="skeleton-line shimmer"></div>
          <div className="skeleton-line shimmer"></div>
          <div className="skeleton-line wide shimmer"></div>
          <div className="skeleton-line wide shimmer"></div>
        </div>
      </div>
    </div>
  );
}
